var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "filter-saver" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogOpen,
            "show-close": true,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogOpen = $event
            },
          },
        },
        [
          _c("div", { staticClass: "filter-saver__title" }, [
            _vm._v("Save to Watchlist"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "filter-saver__name" }, [
            _c(
              "div",
              {
                staticClass: "filter-saver__subtitle",
                class: { error: _vm.nameError },
                attrs: { div: "" },
              },
              [_vm._v("\n        Filter group name\n      ")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filterName,
                  expression: "filterName",
                },
              ],
              staticClass: "filter-saver__name-field",
              class: { error: _vm.nameError },
              attrs: {
                type: "text",
                placeholder: "Enter a name for this filter group",
              },
              domProps: { value: _vm.filterName },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.filterName = $event.target.value
                },
              },
            }),
            _vm._v(" "),
            _vm.nameError
              ? _c("div", { staticClass: "input-error" }, [
                  _vm._v(
                    "\n        You need to give this filter group a name (eg. Anti-Money Laundering\n        in Europe)\n      "
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "filter-saver__selected" }, [
            _c(
              "div",
              { staticClass: "filter-saver__subtitle", attrs: { div: "" } },
              [_vm._v("Selected filters")]
            ),
            _vm._v(" "),
            _vm.searchQuery
              ? _c(
                  "div",
                  { staticClass: "filter-saver__selected-wrapper" },
                  _vm._l(_vm.searchQuery, function (group, index) {
                    return _c("div", {
                      key: index,
                      staticClass: "filter-saver__selected-group",
                    })
                  }),
                  0
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "filter-saver__selected" },
            [
              _c(
                "div",
                { staticClass: "filter-saver__subtitle", attrs: { div: "" } },
                [_vm._v("\n        Alert service email preferences\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  attrs: { placeholder: "Select" },
                  model: {
                    value: _vm.value,
                    callback: function ($$v) {
                      _vm.value = $$v
                    },
                    expression: "value",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "filter-saver__buttons" }, [
            _c("button", { staticClass: "save-btn", on: { click: _vm.save } }, [
              _vm._v("Save"),
            ]),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "cancel-btn", on: { click: _vm.cancel } },
              [_vm._v("Cancel")]
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }